export const constructPhoneNumberFromCallingCodeAndNationalNumber = (
  countryCallingCode: string,
  nationalNumber: string | undefined,
): string => {
  if (!nationalNumber) {
    return '';
  }
  return `+${countryCallingCode}${nationalNumber}`;
};
